import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import {
  ErrorMessage,
  SalesPortalCheckoutRecoveryRequest,
  SalesPortalCheckoutRecoveryResponse,
} from 'types';
import { client } from 'utils/api-client';

// Redeems an abandoned-checkout recovery magic link (spec Item 11). The server signs
// the buyer in and binds the session to their profile in the checkout's gym; the
// response says where to resume. Always an explicit POST — never a GET — so email
// scanners that prefetch the link cannot consume it.
const redeemCheckoutRecovery = (
  payload: SalesPortalCheckoutRecoveryRequest,
): Promise<AxiosResponse<SalesPortalCheckoutRecoveryResponse>> => {
  return client.post('/auth/checkout-recovery/', payload);
};

export default function useCheckoutRecovery(): UseMutationResult<
  AxiosResponse<SalesPortalCheckoutRecoveryResponse>,
  AxiosError<ErrorMessage>,
  SalesPortalCheckoutRecoveryRequest
> {
  return useMutation(redeemCheckoutRecovery);
}
